import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EnvSelectorComponent} from "./env-selector.component";
import {FormsModule} from "@angular/forms";


@NgModule({
  declarations: [
    EnvSelectorComponent
  ],
  exports: [
    EnvSelectorComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class EnvSelectorModule {
}
